/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-10 17:16:40
 * @FilePath: \app-client-h5\src\pages\rechargeWater\services.js
 */
import http from '../../utils/http';
/**
 * 支付
 */
 export function rechargePay(params) {
  return http("post", '/order/weChat/h5Recharge',params);
}
/**
 * 微信后端发送h5请求
 */
 export function sendH5PayRequest(params) {
  return http("post", '/order/weChat/sendH5PayRequest',params);
}
//水费模板
export function getTemplate() {
  return http("get", '/room/usewater/getTemp');
}
//
export function count() {
  return http("get", '/order/getRechargeMoney');
}
/**
 * 支付
 */
 export function getPayResult(params) {
  return http("post", '/order/getPayResult',params);
}


